export default "__VITE_ASSET__BNKbHMEL__"